import biometricMesh from "../assets/biometric_facial_mesh.png";
import secureQR from "../assets/secure_qr_handshake.png";
import fingerprintMap from "../assets/fingerprint_map.png";
import irisScan from "../assets/iris_scan.png";
import voiceBiometrics from "../assets/voice_biometrics.png";
import oldFacialMesh from "../assets/facial_mesh.png";

export const videoData = {
  Banner: [
    {
      id: 1,
      title: "Legitimately U: Secure Identity",
      subtitle: "The Future of Passwordless Authentication",
      thumbnail: biometricMesh,
      url: "https://www.youtube.com/watch?v=6ZfuNTqbHE8",
      description: "Discover the elite biometric security protocols powering Legitimately U. From end-to-end encrypted handshakes to zero-trust architecture, see how we are redefining digital identity."
    },
  ],
  "Security Features": [
    {
      id: 1,
      title: "Facial Mesh Analysis",
      subtitle: "Next-Gen Biometric Verification",
      thumbnail: biometricMesh,
      url: "https://www.youtube.com/watch?v=iN-oxrAtv14",
      description: "An in-depth look at our advanced facial mesh technology. We process thousands of data points to ensure that the physical user is legitimate, preventing deepfakes and spoofing attempts."
    },
    {
      id: 2,
      title: "Secure QR Handshake",
      subtitle: "Encrypted Device Syncing",
      thumbnail: secureQR,
      url: "https://www.youtube.com/watch?v=z-YO_x4xLws",
      description: "Learn how the LU secure QR protocol establishes a temporary, high-security channel between your desktop browser and mobile device for instant authentication."
    },
    {
      id: 3,
      title: "Zero-Trust Protocol",
      subtitle: "Architecture Overview",
      thumbnail: fingerprintMap,
      url: "https://www.youtube.com/watch?v=KKziOmsJxzE",
      description: "Our core security philosophy: Never Trust, Always Verify. See how LU manages identity tokens without ever storing vulnerable user passwords on our servers."
    }
  ],
  "Integration Guides": [
    {
      id: 1,
      title: "Universal SDK Setup",
      subtitle: "Web & Mobile Integration",
      thumbnail: irisScan,
      url: "https://www.youtube.com/watch?v=HkbzQ2RLtms",
      description: "A step-by-step developer guide to integrating Legitimately U into your existing tech stack. Support for React, Vue, Angular, and native mobile platforms."
    },
    {
      id: 2,
      title: "Custom UI Customization",
      subtitle: "Branding the LU Experience",
      thumbnail: voiceBiometrics,
      url: "https://www.youtube.com/watch?v=v_rZG9pESNY",
      description: "Customize the LU login modal and confirmation screens to match your brand's aesthetic while maintaining the highest security standards."
    },
    {
      id: 3,
      title: "Mobile Auth Flow",
      subtitle: "Native SDK Implementation",
      thumbnail: oldFacialMesh,
      url: "https://www.youtube.com/watch?v=isC-mdd-Kuw",
      description: "Implementing biometric authentication in native iOS and Android applications using the Legitimately U Mobile SDK."
    }
  ],
};
